import {ReactComponent as Loader} from "@assets/svg/loader.svg";

export default function DataLoading ({style={}}) {
  return (
    <div style={style} className="d-flex flex-col h-100 shrink-0  w-100 align-items-center justify-center">
          <Loader height={20} width={20}  />
    </div>
  );
}
